import React from 'react';
import { useQuestion } from '@components/PracticeV2/Provider/PracticeProvider';
import useIsMobile from '@utils/hooks/useIsMobile';
import { TabProvider, Tab, TabPanel, TabList } from '@components/Shared/TabsDefaultSkin';
import { NavigationHeaderWrap } from '@components/QuestionAssets/QuestionAssets.style';
import ResizableTray from '@components/Atoms/ResizableTray';
import { ContentRow, MainContent } from '@components/Atoms/ResizableTray/ResizableTray.style';

import PracticeControlButtons from '../PracticeControlButtons';
import Question from '../Question';
import QuestionAssets from '../QuestionAssets';
import QuestionsHeader from '../QuestionsHeader';

const QuestionBody = () => (
  <>
    <QuestionsHeader />
    <Question />
    <PracticeControlButtons />
  </>
);

const PracticeContent = () => {
  const question = useQuestion();
  const isMobile = useIsMobile();

  // no assets — question fills full width
  if (!question?.question?.shared_assets?.length) {
    return (
      <MainContent>
        <QuestionBody />
      </MainContent>
    );
  }

  // mobile — tabbed view
  if (isMobile) {
    return (
      <div
        style={{
          display: 'flex',
          height: '100%',
          flex: 1,
          width: '100%',
          flexDirection: 'column',
        }}
      >
        <TabProvider defaultTab="ShowQuestions">
          <NavigationHeaderWrap>
            <TabList>
              <Tab tabKey="Assets">Assets</Tab>
              <Tab tabKey="ShowQuestions">Show Questions</Tab>
            </TabList>
          </NavigationHeaderWrap>
          <TabPanel tabKey="Assets">
            <QuestionAssets />
          </TabPanel>
          <TabPanel tabKey="ShowQuestions">
            <QuestionBody />
          </TabPanel>
        </TabProvider>
      </div>
    );
  }

  // desktop — resizable tray
  return (
    <ContentRow>
      <ResizableTray
        id="resource"
        side="left"
        label="Resource"
        defaultWidth={320}
        minWidth={200}
        maxWidth={600}
        defaultOpen
      >
        <QuestionAssets />
      </ResizableTray>
      <MainContent>
        <QuestionBody />
      </MainContent>
    </ContentRow>
  );
};

export default PracticeContent;
